import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { Edge } from '@xyflow/react';

export function FN_GRAPH_UPDATE__edge_remove(edges_data: Edge[], graph: DTO_GRAPH__instance) {
  let edges_ids = edges_data.map(edge => edge.id);

  let { edges } = graph;
  edges = edges.filter(edge => edges_ids.includes(edge.edge_id));

  if (edges.is_empty()) return false;

  graph.edges__delete(edges);

  return true;
}
